import GeolocationReason from './GeolocationReason';

export default GeolocationReason;
